import React from 'react';
import {
	Theme,
	makeStyles,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
} from '@material-ui/core';
import { Control, FieldValues, Controller, DeepMap, FieldError } from 'react-hook-form';
import { SelectLayoutItem } from 'models/InputLayoutItem';

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		width: '100%',
		marginTop: 24,
		'& .MuiOutlinedInput-root': {
			borderRadius: 8,
			backgroundColor: 'white',
		},
	},
}));

interface SelectProps extends SelectLayoutItem {
	control: Control<FieldValues>;
	errors: DeepMap<FieldValues, FieldError>;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SelectLayout = ({
	label,
	name,
	control,
	defaultValue,
	options,
	disabled,
	errors,
	handleChange,
}: SelectProps) => {
	const classes = useStyles();

	return (
		<>
			<Controller
				key={name}
				name={name}
				control={control}
				defaultValue={defaultValue}
				render={({ field }) => (
					<FormControl
						variant="outlined"
						className={classes.container}
						error={errors[name] !== undefined}
						disabled={disabled}

					>
						<InputLabel htmlFor={name}>{label}</InputLabel>
						<Select
							label={label}
							//onChangeCapture={handleChange}
							{...field}
							onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
								field.onChange(event);
							}}
						>
							<MenuItem value="">
								<em>Elige una opción</em>
							</MenuItem>
							{options?.map((option, index) => (
								<MenuItem key={index} value={option.value}>
									{option.label}{' '}
								</MenuItem>
							))}
						</Select>
						<FormHelperText>{errors[name]?.message}</FormHelperText>
					</FormControl>
				)}
			/>
		</>
	);
};
